import { lazy } from 'react';

const Leads = lazy(() => import('./AdminLeadsPage'));

const AdminLeadsConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: 'admin/leads',
      element: <Leads />,
    },
  ],
};

export default AdminLeadsConfig;
